// Minimal Markdown renderer — headers, lists, bold, tables, paragraphs
export default function Markdown({ text = "", className = "" }) {
  const html = renderMarkdown(text);
  return <div className={`md-view ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}

function esc(s) {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

function inline(s) {
  // bold
  s = s.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  // italic
  s = s.replace(/(^|[^*])\*(?!\s)(.+?)\*(?!\*)/g, "$1<em>$2</em>");
  // inline code
  s = s.replace(/`([^`]+)`/g, "<code>$1</code>");
  return s;
}

function renderMarkdown(text) {
  const lines = text.split(/\r?\n/);
  const out = [];
  let inList = false;
  let inTable = false;
  let tableRows = [];

  const flushList = () => {
    if (inList) { out.push("</ul>"); inList = false; }
  };
  const flushTable = () => {
    if (inTable) {
      const [head, ...rest] = tableRows;
      const headCells = head.map((c) => `<th>${inline(esc(c))}</th>`).join("");
      const bodyRows = rest.filter((r) => !/^-{2,}/.test(r.join(""))).map(
        (r) => `<tr>${r.map((c) => `<td>${inline(esc(c))}</td>`).join("")}</tr>`
      ).join("");
      out.push(`<table><thead><tr>${headCells}</tr></thead><tbody>${bodyRows}</tbody></table>`);
      inTable = false; tableRows = [];
    }
  };

  for (const raw of lines) {
    const line = raw.replace(/\s+$/, "");
    if (!line.trim()) { flushList(); flushTable(); continue; }
    if (line.trim().startsWith("|") && line.includes("|")) {
      flushList();
      inTable = true;
      const cells = line.trim().replace(/^\|/, "").replace(/\|$/, "").split("|").map((c) => c.trim());
      tableRows.push(cells);
      continue;
    } else if (inTable) {
      flushTable();
    }
    if (/^###\s+/.test(line)) { flushList(); out.push(`<h3>${inline(esc(line.replace(/^###\s+/, "")))}</h3>`); continue; }
    if (/^##\s+/.test(line))  { flushList(); out.push(`<h2>${inline(esc(line.replace(/^##\s+/, "")))}</h2>`); continue; }
    if (/^#\s+/.test(line))   { flushList(); out.push(`<h1>${inline(esc(line.replace(/^#\s+/, "")))}</h1>`); continue; }
    if (/^[-*]\s+/.test(line)) {
      if (!inList) { out.push("<ul>"); inList = true; }
      out.push(`<li>${inline(esc(line.replace(/^[-*]\s+/, "")))}</li>`);
      continue;
    }
    flushList();
    out.push(`<p>${inline(esc(line))}</p>`);
  }
  flushList();
  flushTable();
  return out.join("\n");
}
